// extracted by mini-css-extract-plugin
module.exports = {"faq":"help_faq__2cIzK"};